import enc from "crypto-js/enc-hex";
import SHA256 from "crypto-js/sha256";
import { RelayNetworkLayerRequestBatch } from "react-relay-network-modern";
const createGETUrl = (fetchUrl, persistedQuery) => {
  const url = new URL(fetchUrl);
  for (const [key, value] of Object.entries(persistedQuery)) {
    const parameter = typeof value === "object" ? JSON.stringify(value) : String(value);
    url.searchParams.append(key, parameter);
  }
  return url.toString();
};
export const persistedQueries = (options = {}) => next => async request => {
  if (request instanceof RelayNetworkLayerRequestBatch) {
    return next(request);
  }
  const {
    name,
    operationKind,
    text: queryText
  } = request.operation;
  const persistedQuery = {
    extensions: {
      persistedQuery: {
        sha256Hash: queryText && SHA256(queryText).toString(enc),
        version: 1
      }
    },
    operationName: name,
    variables: request.variables
  };
  const originalMethod = request.fetchOpts.method;
  // If requested, use GET for queries (but not mutations)
  if (options.useGETForHashedQueries && operationKind === "query") {
    var _request$fetchOpts;
    request.fetchOpts.method = "GET";
    (_request$fetchOpts = request.fetchOpts) === null || _request$fetchOpts === void 0 || delete _request$fetchOpts.body;
    if (request.fetchOpts.url) {
      request.fetchOpts.url = createGETUrl(request.fetchOpts.url, persistedQuery);
    }
  } else {
    request.fetchOpts.body = JSON.stringify(persistedQuery);
  }
  const response = await next(request);
  if (response.errors && response.errors.length === 1) {
    if (response.errors[0].message === "PersistedQueryNotSupported") {
      return response;
    }
    if (response.errors[0].message === "PersistedQueryNotFound") {
      request.fetchOpts.method = originalMethod;
      request.fetchOpts.body = JSON.stringify(Object.assign({}, persistedQuery, {
        query: queryText
      }));
      return next(request);
    }
  }
  return response;
};